/* eslint-disable no-unused-vars */
import Vue from "vue";
import cuid from "cuid";

import api from "@/common/api";
import { createJLAI } from "@/common/functions";

import { sleep, ObjectToSortedArrayReverse } from "@/helpers/utils";

import { FETCH, CREATE, REMOVE, LISTEN, RESPOND } from "../actions";
import { SET_KEY_NESTED, DEL_KEY_NESTED } from "../mutations";

const MESSAGES = [
  "Kia Orana, ici J.L. AI ! Que puis-je faire pour toi?",
  "Reviens aux fondamentaux. Fais une pause et focus sur la gratitude. Si besoin, fais la méditation du tube pranique et mets-toi en mouvement. BOUGE !",
  "La méditation du tube pranique consiste à visualiser un tube de lumière dorée qui provient de la source de l'Univers et qui passe autour de soi pour se connecter à la terre. Cette méditation permet de se purifier et de s'apaiser, ainsi que de s'ancrer au sol tout en se connectant à la source. Elle est préconisée chaque matin pour se mettre dans une émotion d'amour et d'abondance. Est-ce que tu la fais chaque matin ? Qu'est-ce que tu as mangé dernièrement ?",
  " le pain blanc doit être évité pour être dans des vibrations élevées. Il est recommandé de le remplacer par du pain noir, du quinoa, du riz complet, du boulgour, du millet ou du sarrasin. Il est donc conseillé de bannir le pain blanc de votre alimentation si vous voulez monter votre niveau vibratoire",
  `Pour aujourd'hui, je te conseille cette recette : Blanc de poulet au Vinaigre de cidre. <br />1. Dans 1 assiette, mettre la farine, sel, poivre et mélanger.
2. Enrober les blancs de poulet avec cette préparation.<br />
3. Dans une sauteuse, faire chauffer l’huile et faire dorer les blancs depoulet.<br />
4. Ajouter les champignons, la pomme coupée en cube et lesoignons.<br />
5. Remuer régulièrement.<br />
6. Lorsque le poulet est bien doré, retirer dans un plat avec les champignons, la pomme et les
oignons.<br />
7. Dans la sauteuse, ajouter le mascarpone, la farine, le vinaigre de cidre. Remuer.<br />
8. Rajouter le mélange poulet, champignons, oignons et laisser cuire à feu doux 15 mn.<br />
9. Servir accompagné de quinoa.`,
  "Ton cerveau fait du zapping. Tu dois te concentrer uniquement sur ce qui est important. Commencez par vous poser les bonnes questions. Pourquoi est-ce important pour vous ? Qu'est-ce que cela apportera à votre vie ? Définissez des objectifs clairs et précis et écrivez-les. Puis, concentrez-vous sur une tâche à la fois, en utilisant la méthode de blocs de temps de 50 minutes. Pratiquez la méditation pour améliorer votre capacité d'attention et vous aider à rester concentré sur l'essentiel. Bougez.",
  `Si vous rencontrez des difficultés avec des personnes qui vous tirent vers le bas sur le plan énergétique. Voici ce que je vous recommande : <br />
1. Évitez autant que possible les interactions avec ces personnes. Si cela est impossible, limitez le temps que vous passez avec elles. <br />
2. Protégez votre propre énergie en vous entourant de lumière blanche et en vous visualisant dans une bulle protectrice. <br />
3. Cultivez des relations avec des personnes qui ont des vibrations élevées et qui vous soutiennent dans votre développement spirituel.<br />
4. Travailler sur vous-même en élevant vos vibrations et en vous ajustant à l'Univers. Plus vous êtes fort et connecté, moins vous serez affecté par les vampires énergétiques.<br />
`,
];

const getInitState = () => ({
  items: {},
});

const getters = {
  itemsSorted: (state) => () => {
    return ObjectToSortedArrayReverse(state.items, "createdAt");
  },
};

const mutations = {
  [SET_KEY_NESTED](state, { key, id, ...payload }) {
    Vue.set(state[key], id, payload);
  },
  [DEL_KEY_NESTED](state, { key, id }) {
    Vue.delete(state[key], id);
  },
};

const actions = {
  async [FETCH]() {},
  async [CREATE]({ commit }, data) {
    const id = cuid();
    console.log("CREATE", id);
    commit(SET_KEY_NESTED, { key: "items", id, ...data });
  },
  async [REMOVE]() {},

  async [LISTEN]() {},
  async [RESPOND](_, payload) {
    try {
      console.log("pay", payload);
      // const appId = "-NVohLciiLgr0_8vvPA_";
      const appId = "-NVfA0gf2dGNadi6EeQ9";

      const { data } = await createJLAI({ appId, ...payload });

      // const { data } = await api.post("/ai-text/jl-ai", { appId, ...payload });
      /*  const { currentMessage } = payload;

      await sleep(4000);
      const data = { result: MESSAGES[currentMessage] }; */
      console.log("Data", data);
      return { isSuccess: true, ...data };
    } catch (error) {
      console.log("ERR", error);
      return { isSuccess: false };
    }
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  getters,
  mutations,
  actions,
};
